import { createStyles } from '@mui/styles';

export const DeleteConfirmationModalStyles = () =>
  createStyles({
    modalContent: {
      minWidth: '400px',
      padding: '24px',
    },
    warningText: {
      color: '#d32f2f',
      fontWeight: 600,
      marginBottom: '16px',
    },
    rulesList: {
      marginTop: '16px',
      maxHeight: '300px',
      overflowY: 'auto',
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '8px',
      marginTop: '24px',
    },
  });
